 export const hanaLines = {
  antique: {
    lines: [
      { speaker: "Hana", text: "Ink stains my hands—\nI carve stories in your skin.\nDo you feel the truth?" },
      { speaker: "Randy", text: "Once got 'YOLO' inked.\nI felt something... maybe itch?\nThat still counts, right... yes?" },

      { speaker: "Hana", text: "The needle hums low,\nSkin opens, blood calls the art.\nWhat is it we seek?" },
      { speaker: "Randy", text: "I seek nachos first.\nThen truth, love, or spicy soup.\nDo they sell that here?" },

      { speaker: "Hana", text: "A butterfly flies—\nWings hold the memory's weight.\nWill it live or die?" },
      { speaker: "Randy", text: "Mine flew into glass.\nI named him Jeff. He knew fear.\nRest in wings, my bro." },

      { speaker: "Hana", text: "The flame burns so bright—\nBut the shadow swallows light.\nDo we chase the dark?" },
      { speaker: "Randy", text: "I chased my own sock\ninto a laundry portal—\nShould I have let go?" },

      { speaker: "Hana", text: "Tattoos fade with time,\nBut the pain still wears its mark.\nHow deep is your past?" },
      { speaker: "Randy", text: "One spring break in Guam,\na dolphin judged my dance moves.\nI still dream of that." },

      { speaker: "Hana", text: "Every line, a choice—\nEach stroke a new beginning.\nWill you bear it well?" },
      { speaker: "Randy", text: "I once bore a cat.\nIt climbed me like destiny.\nI have the scar still." }
    ],
    voices: [
      "hana_antique1",
      "hana_antique2",
      "hana_antique3",
      "hana_antique4",
      "hana_antique5",
      "hana_antique6"
    ],
    randyVoices: [
      "randy_hana1",
      "randy_hana2",
      "randy_hana3",
      "randy_hana4",
      "randy_hana5",
      "randy_hana6"
    ]
  }
};

export default hanaLines;
